
<form>
  <dx-form
    (onOptionChanged)="onOptionChange($event)"
    [readOnly]="readOnly"
    [formData]="formData"
    (onFieldDataChanged)="onFieldDataChanged($event)">
  </dx-form>
</form>
